import { httpGet } from "../Backend";
import HttpStatusCodes from "../HttpStatusCodes";

const root = "api/operators";

export interface ViewModel {
    operatorAccess: OperatorAccess;
}

export interface OperatorAccess {
    level: number;
}

export interface AccountRolesAndPermissionsResponse {
    accountRolesAndPermissionsResponse: ViewModel;
}

export async function accountRolesAndPermissions(targetUserId: string) {
    var response = await httpGet(`${root}/accountRolesAndPermissions?targetUserId=${targetUserId}`)
    return response.data as AccountRolesAndPermissionsResponse;
}